import { AuthConfig } from 'angular-oauth2-oidc';

export const baseWebAuthConfig: AuthConfig = {
  responseType: 'code',
  scope: 'openid profile email offline_access',
  clearHashAfterLogin: false,
  sessionChecksEnabled: false,
} as AuthConfig;
